/**
 * provides react-imported-component configuration
 * @param {ImportedConfiguration} config
 */
export var configure = function (config) { return config; };
